import React from 'react';

export default function EventDrawer({ isOpen, onClose, event, userRole }) {
    if (!isOpen || !event) return null;

    return (
        <>
            {/* Затемнение заднего фона */}
            <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity z-40" onClick={onClose} />

            {/* Выдвижная панель справа */}
            <div className="fixed right-0 top-0 h-full w-96 bg-white shadow-2xl z-50 p-6 flex flex-col transform transition-transform border-l border-gray-100 animate-slide-in">
                {/* Кнопка закрытия */}
                <div className="flex justify-between items-start border-b border-gray-100 pb-4 mb-5">
                    <div>
                        <span className={`text-[10px] font-extrabold uppercase tracking-widest px-2.5 py-1 rounded-lg ${event.isPersonal ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}`}>
                            {event.isPersonal ? 'Личное' : event.type}
                        </span>
                        <h2 className="text-xl font-black text-gray-900 mt-2 leading-tight">{event.title}</h2>
                    </div>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-800 transition-colors bg-gray-50 hover:bg-gray-100 rounded-full p-1.5">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                </div>

                {/* Контент события */}
                <div className="flex-1 flex flex-col gap-5 overflow-y-auto pr-2">
                    
                    <div className="bg-gray-50 p-4 rounded-2xl border border-gray-100">
                        <div className="flex items-center gap-3 mb-3">
                            <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 text-sm">👥</div>
                            <div>
                                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">Принадлежность</p>
                                <p className="text-sm font-bold text-gray-800">{event.group}</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600 text-sm">👤</div>
                            <div>
                                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">Автор</p>
                                <p className="text-sm font-bold text-gray-800">{event.creator}</p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1.5 flex items-center gap-2">🗓 Дата и время</p>
                        <p className="text-base font-bold text-gray-800">{event.dateStr} в 12:00</p>
                    </div>

                    <div>
                        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1.5 flex items-center gap-2">📝 Описание</p>
                        <p className="bg-blue-50/50 p-4 rounded-xl text-sm font-medium text-gray-700 leading-relaxed border border-blue-100/50">
                            {event.description}
                        </p>
                    </div>
                </div>

                {/* Динамическая кнопка действия внизу панели */}
                <div className="border-t border-gray-100 pt-5 mt-auto">
                    {event.isPersonal ? (
                        <button className="w-full bg-blue-50 text-blue-600 hover:bg-blue-100 font-bold py-3 px-4 rounded-xl transition-colors border border-blue-200">
                            Редактировать заметку
                        </button>
                    ) : userRole === 'STUDENT' ? (
                        <button className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-4 rounded-xl shadow-sm transition-colors">
                            Перейти к заданию
                        </button>
                    ) : (
                        <button className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-4 rounded-xl shadow-sm transition-colors">
                            Посмотреть результаты (Дашборд)
                        </button>
                    )}
                </div>
            </div>
        </>
    );
}